import * as React from 'react';
import TypographyHeading from './Typography/TypographyHeading';

export interface IEmptyResultProps {
  message?: string;
  title?: string;
}

export default function EmptyResult({message}: IEmptyResultProps) {
  return (
    <TypographyHeading
      tag="h3"
      size="small"
      color="white"
      textAlign="center"
      style={{padding: '20px', border: '1px solid #fff', borderRadius: 8}}
    >
      {message ?? 'No Results Found'}
    </TypographyHeading>
  );
}
